import { Component, Input } from '@angular/core';
import { NgModel } from '@angular/forms';
import { RegularExpressionPattern } from '@shared/_constants';
import { BVD_DEFAULT_LIMIT } from '../bvd-ids-limit/bvd-ids-limit.directive';
import * as _ from 'lodash-es';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-filter-identification-number',
  templateUrl: './filter-identification-number.component.html',
  styleUrls: ['./filter-identification-number.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class FilterIdentificationNumberComponent {
  @Input() filter: any;
  @Input() readOnly = false;
  formDirty = false;

  regularExpressionPattern: typeof RegularExpressionPattern = RegularExpressionPattern;
  bvdIdNumbersLimit = BVD_DEFAULT_LIMIT;
  submitClicked = false;

  ShowValidationMessage(item: NgModel): boolean {
    return (item.errors || false) && (this.submitClicked || !item.pristine || item.touched);
  }
  removeWhitespace(stringContent: string) {
    return !_.isEmpty(stringContent) ? stringContent.replace(/\s/g, '') : stringContent;
  }
}
